import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import PaymentOption from './payment/paymentOption';
import UserDetailPopUp from '../../../components/Elements/userDetailPopUp/userDetailPopUp';
import CourseDetail from '../../coursDetail/courseDetail';
import ApiService from '../../../services/ApiService';
import { useDispatch, useSelector } from 'react-redux';
import { setCurseHadings } from '../../../reducers/reposReducers';
import { API_URL, API_URL_getCourseWWWInfoPortal} from '../../../config';
import ComplateData from "./complateData.js"
import './variantSummary.css';
import axios from 'axios';

const VariantSummary = (props) => {
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    const apiService = ApiService.getInstance();
    const date = new Date();
    let globalResponse;
    const key = localStorage.getItem('keyURL');
    const userID = localStorage.getItem('participantUsersID');
    const guID =localStorage.getItem("guid")
    const [isFullData, setIsFullData] = useState(true)
    const [isNeedComplitedData, setComplitedData] = useState(false)
   const userDataCheck = JSON.parse( localStorage.getItem('users'));
   const parcipientNameDataCheck = JSON.parse( localStorage.getItem('selectedPartipient'));
   const repo =  useSelector((state) => state.repos.chName)
    console.log(repo)
   let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    if (month < 10) {
        month = '0' + month;
    }
    const [reload, setReload]=useState(true)
    let adultPersonForUser = JSON.parse(localStorage.getItem('selectedPayers'));
    let parcipientName =  localStorage.getItem('userName');
    if(parcipientName == null){
        parcipientName =  localStorage.getItem('payerName');    
    }
    // {
    //     "usersID": 18442,
    //     "login": null,
    //     "firstName": "Damian",
    //     "lastName": "Gąska",
    //     "genderDVID": 1,
    //     "dateOfBirdth": "01/01/0001 00:00:00",
    //     "pesel": "53062075174",
    //     "street": "wolska",
    //     "building": "21",
    //     "flat": "",
    //     "city": "kazimierz",
    //     "postalCode": "32-112",
    //     "email": "pinyin@getmail.fun",
    //     "phone": "634653423",
    //     "personalDataProcessingConsent": true,
    //     "active": "1",
    //     "currentPurchaseKey": null,
    //     "consentReceiveSmsEmailPhone": false,
    //     "marketingAgreement": false,
    //     "memberCardNumber": ""
    // }
  

    
    const startDate = `${year}-${month}-${day}`;
    const dispatch = useDispatch();
    const usersParticipant = useSelector((state) => state.repos.usersParticipant);
    const users = useSelector((state) => state.repos.users);
    let coursesHeadings;
    const proxySendURL = `${API_URL}ProxySend`
    const [entryFee, setEntryLocalFee] = useState('0');
    const [openMonth, setOpenMonth] = useState(false);
    const [res, setRes] = useState([]);
    const [formData] = useState({
        courseHeadingName: key, // 'Żwiry-K1', // TODO będzie przychodić w linku w gecie
        attendanceStartDate: `${props.start}`,
        current_LocalizationsID: '0',
    });
    const [CheckUserEntryFeeParams, setCheckUserEntryFeeParams] = useState({
        usersID: userID, // 'Żwiry-K1', // TODO będzie przychodić w linku w gecie
        localizationsID: coursesHeadings,
        current_LocalizationsID: '0',
    });
    let responseCoursesHeadingsID;
    if(userID == undefined|| userID == ""){
        userID = localStorage.getItem('usersID');
    }
    const nextOrComplted = (arg, arg1, arg2) =>{
 
            props.next(arg, arg1, arg2)
      
    }
    const methodProxyGetMessage = () => {
        const proxyGetMessageURL = `${API_URL}ProxyGetMessage?requestId=` + globalResponse;
        axios
            .get(proxyGetMessageURL, config)
            .then((proxyGetMessageUrlResponse) => {
                if (proxyGetMessageUrlResponse.data.responseBody != null) {
                if(proxyGetMessageUrlResponse.data.responseBody.status == 200){
             
                    localStorage.setItem('pushURL', proxyGetMessageUrlResponse.data.responseBody.body.html)
                    // sePaymentReady(20)
       
                }             
                    else if(proxyGetMessageUrlResponse.data.responseBody.status == 401){
                        // history.push('/Error_ogolny');
                     
                    }else  
                        if(proxyGetMessageUrlResponse.data.responseBody.includes("Trying to get property 'paymentCardID' of non-object in") ){
                            // sePaymentReady(42)
                            //Wiadomość nie można było przygotować płatności ponieważ brak karty
                            //Co robić w tej sytuacji 
                    }else{
                            // sePaymentReady(40)
                        }
                    
                    
                } else if (proxyGetMessageUrlResponse.data.recheck == true) {
                    setTimeout(() => methodProxyGetMessage(), 10000);
                } else if (proxyGetMessageUrlResponse.data.recheck == false) {
                    // sePaymentReady(40)
                }
            })
            .catch(function (error) {
                if (error.response != null) {
                    if (error.response.status == 401) {
                        // history.push('/Error_ogolny');
                    }
                } else {
                    // window.location.replace(
                    //     'https://aden-eds-portal-dev.azurewebsites.net/#/Error_ogolny'
                    // );
                }
            });
    };
    const takeBilett = async (arg, arg1, arg2)=>{
      
        console.log(arg2, parseInt(localStorage.getItem('coursesHeadingsID')))
        await apiService.apiPost('CalculateProductForUser', {
            keyController:'setPurchasingPackages',
            "productsID":arg2.productsID,
            "usersID":userID,
            "localizationsID":3,
            "paymentMethodsDVID":'5',
            "startDate":`${props.start}`,
            "coursesHeadingsID": parseInt(localStorage.getItem('coursesHeadingsID')),
            "current_LocalizationsID":"98",
            "promotionsSalesIDList": "",
            "guid": guID
        }, (response) => {
          if(response.data.succeeded){
            
          }

  
       
     
         
        });
        props.nextToBillet();
        props.next(arg, arg1, arg2)
        props.setVarainBillet({
            amount:arg2.unitAmount,
            count:arg2.numberOfLessons
        })
        
    }
    const methodCheckUserEntryFee = async () => {
        const CheckUserEntryFeeParamsSend = {
            usersID: userID,
            localizationsID: coursesHeadings,
            current_LocalizationsID: '0',
        };
        await apiService
            .asyncApiPost('CheckUserEntryFee', CheckUserEntryFeeParamsSend)
            .then((response) => {
             if(response.responseBody.body != undefined){
      
                props.setFee(
                    response.responseBody.body
                        ? response.responseBody.body.price.toString()
                        : "0"
                );
                setEntryLocalFee(
                    response.responseBody.body
                        ? response.responseBody.body.price.toString()
                        : "0"
                );}
            });

        return 'Finished methodCheckUserEntryFee';
    };

    const methodGetCourseWWWInfo = async () => {
        let urlApi = `${API_URL_getCourseWWWInfoPortal}GetCourseWWWInfoPortal`
        

        if(formData.courseHeadingName == null||formData.courseHeadingName == undefined){
            console.log(formData.courseHeadingName,"check");
            formData.courseHeadingName = repo;
            console.log(formData.courseHeadingName,"check");
        }
        fetch(
            `${urlApi}`,
            {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: null,
                },
                body: JSON.stringify(formData),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((response) => {
              
                dispatch(setCurseHadings(response.body));
                localStorage.setItem('coursesHeadings', JSON.stringify(response.body));
                setCheckUserEntryFeeParams({
                    ...CheckUserEntryFeeParams,
                    localizationsID: response.body.localizationsID,
                });
          
                coursesHeadings = response.body.localizationsID;
                localStorage.setItem('localizationsID', response.body.localizationsID);
                localStorage.setItem('coursesHeadingsID', response.body.coursesHeadingsID);
                localStorage.setItem('startingDate', response.body.startingDate);
                localStorage.setItem('endData', response.body.closingDate);
                responseCoursesHeadingsID = response.body.coursesHeadingsID;
                methodGetPriceByCourseHeadingsID();
                methodCheckUserEntryFee();
            });

        return 'Finished methodGetCourseWWWInfo';
    };

    const methodGetPriceByCourseHeadingsID = async () => {
        console.log(responseCoursesHeadingsID,"check");
        if(responseCoursesHeadingsID == null){
            console.log(`1 ${responseCoursesHeadingsID}`);
            responseCoursesHeadingsID =  localStorage.getItem('coursesHeadingsID');
            console.log(`2 ${responseCoursesHeadingsID}`);
        
        }
        await apiService
            .asyncApiPost('GetPriceByCourseHeadingsID', {
                coursesHeadingsID: responseCoursesHeadingsID,
                current_LocalizationsID: '0',
                startDate: `${props.start}`,
            })
            .then((response) => {
           
                if (response.body.length != 0) {
                   
                    let dataSort = response.body.sort(function (a, b) {
                        if (a.paymentTypesDVID > b.paymentTypesDVID) {
                            return 1;
                        }
                        if (a.paymentTypesDVID < b.paymentTypesDVID) {
                            return -1;
                        }
                        return 0;
                    });

                    response.body.map((e) => {
                        if (e.periodsOfValidityDVID === 3) {
                            setOpenMonth(true);
                        }
                    });
             
                    // let sortRespons = response.body
                   
                    setRes(dataSort);
                } else {
                }
            });

        return 'Finished methodGetPriceByCourseHeadingsID';
    };
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'checkout',
            'step' : `Wartian cenowy`
        });
        methodGetCourseWWWInfo();
 
          
    }, []);
    return (
        <>
            
                <div className="variantSummary">
                <div className="vairaintSummary_tittle">
                  
                    <div className="vairaintSummary_tittleWrapper">
                        <CustomTittle>Wybierz wariant cenowy</CustomTittle>

                        <div className="variantSummary_option">
                            <div className="tittle_stage">
                                <span className="tittle_content">/ UMOWA ROCZNA</span>
                                <p className="hintTextDot">
                                    ?
                                    <p className="tooltips">
                                         Oferujemy umowy roczne (10-miesięczne).
                                    </p>
                                </p>
                            </div>
                            <div className="paymentOptions">
                                {res.map((payment, index) =>
                                    payment.periodsOfValidityDVID == 1 ? (
                                        payment.paymentTypesDVID == 1 ? (
                                            <PaymentOption
                                            key={"keyVariant" + index}
                                                duration={'zł / rok'}
                                                next={nextOrComplted}
                                                title="PŁATNOŚĆ Z GÓRY"
                                                entry={
                                                    entryFee != null
                                                        ? parseFloat(entryFee).toFixed(2)
                                                        : '0,00'
                                                }
                                                payment={payment}
                                                price={payment.currentPrice}
                                                oneMounth={payment.unitAmount}
                                            ></PaymentOption>
                                        ) : (
                                            <PaymentOption
                                            key={"keyVariant" + index}
                                                duration={'zł / miesiąc'}
                                                next={nextOrComplted}
                                                title="PŁATNOŚĆ RATALNA"
                                                entry={
                                                    entryFee != null
                                                        ? parseFloat(entryFee).toFixed(2)
                                                        : '0,00'
                                                }
                                                payment={payment}
                                                price={payment.currentPrice}
                                                oneMounth={payment.unitAmount}
                                            ></PaymentOption>
                                        )
                                    ) : (
                                        ''
                                    )
                                )}
                                
                            </div>
                            <div className="tittle_stage">
                                <span className="tittle_content">/ KARNET</span>
                                <p className="hintTextDot">
                                    ?
                                    <p className="tooltips">
                                    Oferujemy .
                                    </p>
                                </p>
                            </div>
                            <div className="paymentOptions">
                                {res.map((payment,index) =>
                                    payment.pricelistPositionsTypesDVID == 2 ? (
                                      
                                            <PaymentOption
                                            key={"keyVariant" + index}
                                                duration={'zł / semestr'}
                                                next={takeBilett}
                                                title="KARNET"
                                                isbillet={true}
                                                entry={
                                                    entryFee != null
                                                        ? parseFloat(entryFee).toFixed(2)
                                                        : '0,00'
                                                }
                                                payment={payment}
                                                price={payment.currentPrice}
                                                oneMounth={payment.unitAmount}
                                            ></PaymentOption>
                                     
                                    ) : (
                                        ''
                                    )
                                )}
                            </div>
                        </div>
                        <div className="tittle_stage">
                                <span className="tittle_content">/ UMOWA SEMESTRALNA</span>
                                <p className="hintTextDot">
                                    ?
                                    <p className="tooltips">
                                    Oferujemy umowy semestralne (5-miesięczne).
                                    </p>
                                </p>
                            </div>
                            <div className="paymentOptions">
                                {res.map((payment,index) =>
                                    payment.periodsOfValidityDVID == 2 ? (
                                        payment.paymentTypesDVID == 1 ? (
                                            <PaymentOption
                                            key={"keyVariant" + index}
                                                duration={'zł / semestr'}
                                                next={nextOrComplted}
                                                title="PŁATNOŚĆ Z GÓRY"
                                                entry={
                                                    entryFee != null
                                                        ? parseFloat(entryFee).toFixed(2)
                                                        : '0,00'
                                                }
                                                payment={payment}
                                                price={payment.currentPrice}
                                                oneMounth={payment.unitAmount}
                                            ></PaymentOption>
                                        ) : (
                                            <PaymentOption
                                            key={"keyVariant" + index}
                                                duration={'zł / miesiąc'}
                                                next={nextOrComplted}
                                                title="PŁATNOŚĆ RATALNA"
                                                entry={
                                                    entryFee != null
                                                        ? parseFloat(entryFee).toFixed(2)
                                                        : '0,00'
                                                }
                                                payment={payment}
                                                price={payment.currentPrice}
                                                oneMounth={payment.unitAmount}
                                            ></PaymentOption>
                                        )
                                    ) : (
                                        ''
                                    )
                                )}
                            </div>
                       
                    </div>
                    
                </div>

                <div className="dataSummary_detailsDetails">
                    <div className="columDetials_wrapper">
                        <CustomTittle>Szczegóły zamówienia</CustomTittle>
                        <CourseDetail
                            wrapNavigator={props.wrapNavigator}
                            setWrapNavigator={props.setWrapNavigator}
                            setHeader={(e) => {
                                props.setHeader(e);
                            }}
                            header={props.header}
                        ></CourseDetail>
                        <UserDetailPopUp
           
                                onclick={()=>{props.setNavigator(1,"chooseUser")}} 
                        
                            title="Uczestnik:"
                            label={parcipientName}
                            icon={
                                <svg
                                    width="17"
                                    height="18"
                                    viewBox="0 0 17 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z"
                                        fill="#CC0033"
                                    />
                                </svg>
                            }
                        ></UserDetailPopUp>
                        <UserDetailPopUp
                            onclick={() => {
                                props.setNavigator(2, 'data');
                            }}
                            title="Data rozpoczęcia:"
                            label={
                                props.start.split('-')[2] +
                                '-' +
                                props.start.split('-')[1] +
                                '-' +
                                props.start.split('-')[0]
                            }
                            icon={
                                <svg
                                    width="17"
                                    height="18"
                                    viewBox="0 0 17 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z"
                                        fill="#CC0033"
                                    />
                                </svg>
                            }
                        ></UserDetailPopUp>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VariantSummary;
